module.exports = __webpack_public_path__ + "static/media/SSR.e2909168.md";